import styled from 'styled-components';
import Theme from '../../../styles/Theme/Theme';

export const SvgStyled = styled.svg`
    > path {
        fill: ${({ fill, customColor, theme }) => {
            if (customColor) return theme.color[customColor];
            if (fill && fill !== "none") return fill;
        }};
    };
`;
